import React, { useMemo } from 'react';
import { FaTag } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const BlogSidebar = ({ allPosts }) => {
  const categories = useMemo(() => {
    const cats = {};
    allPosts.forEach(post => {
      if (post.published === false) return;
      const category = post.category || 'Uncategorized';
      cats[category] = (cats[category] || 0) + 1;
    });
    return cats;
  }, [allPosts]);

  const tags = useMemo(() => {
    const tagCounts = {};
    allPosts.forEach(post => {
      if (post.published === false) return;
      (post.tags || []).forEach(tag => {
        tagCounts[tag] = (tagCounts[tag] || 0) + 1;
      });
    });
    return Object.entries(tagCounts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 8)
      .map(([tag]) => tag);
  }, [allPosts]);

  return (
    <div className="space-y-6 sm:space-y-8">
      {/* Categories */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-4 sm:p-6 border border-gray-200 dark:border-gray-700">
        <h4 className="font-semibold text-gray-900 dark:text-white mb-4">
          Categories
        </h4>
        <div className="space-y-1 sm:space-y-2">
          {Object.entries(categories).map(([category, count]) => (
            <Link
              key={category}
              to={`/blog?category=${category}`}
              className="flex items-center justify-between px-3 py-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors group text-sm"
            >
              <span className="text-gray-700 dark:text-gray-300 group-hover:text-emerald-600 dark:group-hover:text-emerald-400 transition-colors">
                {category}
              </span>
              <span className="text-sm text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 px-2 py-0.5 rounded-full">
                {count}
              </span>
            </Link>
          ))}
        </div>
      </div>

      {/* Tags */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-4 sm:p-6 border border-gray-200 dark:border-gray-700">
        <h4 className="font-semibold text-gray-900 dark:text-white mb-4">
          Popular Tags
        </h4>
        <div className="flex flex-wrap gap-1 sm:gap-2">
          {tags.map(tag => (
            <Link
              key={tag}
              to={`/blog?tag=${tag}`}
              className="inline-flex items-center gap-1 px-2 sm:px-3 py-1 text-sm text-gray-600 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-400 bg-gray-100 dark:bg-gray-700 rounded-full hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
            >
              <FaTag className="w-3 h-3" />
              {tag}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogSidebar;